<template>
  <div class="app-shell" :class="{ 'app-shell--game': route.name === 'game' }">
    <RouterView />
    <OverlayStackHost />
    <ToastNotifications />
  </div>
</template>

<script setup lang="ts">
import { RouterView, useRoute } from "vue-router";
import OverlayStackHost from "./components/overlay/OverlayStackHost.vue";
import ToastNotifications from "./components/ToastNotifications.vue";

const route = useRoute();
</script>

<style scoped>
.app-shell {
  --shell-rail: 0px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-shell--game {
  --shell-rail: 220px;
}

@media (max-width: 900px) {
  .app-shell--game {
    --shell-rail: 0px;
  }
}
</style>
